// import packages
import React, {useEffect, useState} from "react";
import {connect} from "react-redux";

// Import assets
import "./about.scss"
import {
    ArrowLeftIcon,
    CheckIcon,
} from "../../assets/images";

// Import Components

// Import utils
import {getPropsFromState} from "../../redux/mapStateToProps";
import {SendMessage} from "../../redux/actions";
import HeaderWrapper from "../../components/HeaderWrapper/HeaderWrapper";
import Subscription from "../../components/subscription/Subscription";
import {generateFileMediaUrl} from "../../utils/generateMediaUrl";
import VisibilitySensor from "react-visibility-sensor";
import {CountUp} from "use-count-up";
import MapModal from "../../components/modal/mapModal/MapModal";


function About(props) {
    const {about, aboutSlider, staticTexts, contact} = props
    const [slideIndex, setSlideIndex] = useState(0);
    const [visible, setVisible] = useState(false)

    const nextSlide = (index) => {
        setSlideIndex(index)

    };

    const prevSlide = (index) => {
        setSlideIndex(index === 0 ? 0 : index - 1)
    };

    function closeModal() {
        setVisible(!visible)
    }

    useEffect(() => {
        window.scroll(0, 0)
    }, []);

    let title = about?.title
    const firstIndex = title.indexOf('%s')
    const lastIndex = title.lastIndexOf('%s')

    if (firstIndex !== -1 && lastIndex !== -1 && firstIndex !== lastIndex) {
        title = title.replace('%s', `${firstIndex === 0 ? "": '&nbsp;'}<span>`);
        title = title.replace('%s', `</span>`);
    }
    return <div className={'about-page'}>
        <HeaderWrapper addressFirst={staticTexts?.header_item_about}
                       title={about.pageName}/>

        <div className="about-wrapper">
            {/*<div className="page-title">{about?.title}</div>*/}
            <div className={'page-title'} dangerouslySetInnerHTML={{__html: title}}>
            </div>
            <div className="counts-wrapper">
                <div className="count-item">
                    <div className={'counter-info'}>
                        <VisibilitySensor>{({isVisible}) => {
                            return (
                                <div className="title">
                                    <CountUp isCounting={isVisible} start={0}
                                             end={Number(staticTexts?.credit_count)}
                                             duration={1} delay={4} easing="linear"/>
                                </div>
                            );
                        }}</VisibilitySensor>
                        <p>{staticTexts?.credit_text}</p>
                    </div>
                    <div className="text">
                        {staticTexts?.credit_description}
                    </div>
                </div>
                <div className="count-item">
                    <div className={'counter-info'}>
                        <VisibilitySensor>{({isVisible}) => {
                            return (
                                <div className="title">
                                    <CountUp isCounting={isVisible} start={0}
                                             end={Number(staticTexts?.family_count)}
                                             duration={1} delay={4} easing="linear"/>
                                    +
                                </div>
                            );
                        }}</VisibilitySensor>
                        <p>{staticTexts?.family_text}</p>
                    </div>
                    <div className="text">
                        {staticTexts?.family_description}
                    </div>
                </div>
                <div className="count-item">
                    <div className={'counter-info'}>
                        <VisibilitySensor>{({isVisible}) => {
                            return (
                                <div className="title">
                                    <CountUp isCounting={isVisible} start={0}
                                             end={Number(staticTexts?.square_count)}
                                             duration={1} delay={4} easing="linear"/>
                                </div>
                            );
                        }}</VisibilitySensor>
                        <p>{staticTexts?.square_text}</p>
                    </div>
                    <div className="text">
                        {staticTexts?.square_description}
                    </div>
                </div>
            </div>

            <div className="page-description" dangerouslySetInnerHTML={{__html: about?.description}}></div>

            <div className="page-text">
                {staticTexts?.about_page_text}
            </div>

            <div className="info-items">
                <div className="info-item">
                    <div className="icon"><CheckIcon/></div>
                    <div className="title">{staticTexts?.about_feasibility_title}</div>
                    <div className="text">{staticTexts?.about_feasibility_description}
                    </div>
                </div>
                <div className="info-item">
                    <div className="icon"><CheckIcon/></div>
                    <div className="title">{staticTexts?.about_construction_title}</div>
                    <div className="text">{staticTexts?.about_construction_description}
                    </div>
                </div>
                <div className="info-item">
                    <div className="icon"><CheckIcon/></div>
                    <div className="title">{staticTexts?.about_analytical_title}</div>
                    <div className="text">{staticTexts?.about_analytical_description}
                    </div>
                </div>
            </div>

            <div className="images-wrapper">
                <img src={generateFileMediaUrl(about?.backgroundImage?.path)} alt="" className="left-img"/>

                <div className="slider-wrapper">
                    <img
                        src={generateFileMediaUrl(aboutSlider[slideIndex]?.mediaMain?.path)} className={'list-img'}
                        alt={""}/>
                    {aboutSlider?.length > 1 &&
                        <div className={`buttons`}>
                            <button className={` prev`}
                                    onClick={() => prevSlide(slideIndex)}
                                    disabled={slideIndex === 0}
                            >
                                <ArrowLeftIcon/>
                            </button>
                            <button
                                className={`next`}
                                disabled={slideIndex === aboutSlider?.length - 1}
                                onClick={() => nextSlide(slideIndex + 1)}>
                                <ArrowLeftIcon/>
                            </button>
                        </div>
                    }
                </div>
            </div>

            <div className="address-wrapper">
                <div className="title">{staticTexts?.about_address_title}</div>
                <div className="address" onClick={() => setVisible(true)}>{contact?.address}</div>
            </div>
        </div>

        {/*<Subscription/>*/}

        {
            visible && <MapModal closeModal={closeModal}
                                 visible={visible}/>
        }
    </div>
}

const mapStateToProps = (state) => getPropsFromState(state, [
    'aboutSlider',
    'staticTexts',
    'about',
    'contact',
    'selectedLanguage'
]);

const mapDispatchToProps = {
    SendMessage
};

export default connect(mapStateToProps, mapDispatchToProps)(About);
